export interface Router {
	id: string
	propertyId?: number
	propertyName?: string
	unitId?: number
	unitName?: string
	type: RouterType
	model: string
	name: string
	domain?: string
	publicIpv4Address?: string
	ipv4Address: string
	ipv6Address?: string
	delegatedIpv6Prefix?: string
	username: string
	password: string
	pppoeUsername?: string
	pppoePassword?: string
	vpnUsername?: string
	vpnPassword?: string
	wifiName?: string
	wifiPassword?: string
	wifiPasswordOnRouter?: string
	defaultWifiPassword?: string
	currentAgreementId?: string
	nextAgreementId?: string
	currentStatusId?: string
}

export interface RouterExtended extends Router {
	currentTenantId?: number
	currentTenantName?: string
	currentPlanId?: string
	currentPlanName?: string
	currentDownloadMbpsLimit?: number
	currentUploadMbpsLimit?: number
	currentStartDate?: string
	currentEndDate?: string
	nextTenantId?: number
	nextTenantName?: string
	nextPlanId?: string
	nextPlanName?: string
	nextDownloadMbpsLimit?: number
	nextUploadMbpsLimit?: number
	nextStartDate?: string
	nextEndDate?: string
	statusDate?: string
	norhartResponseMilliseconds?: number
	googleResponseMilliseconds?: number
	youTubeResponseMilliseconds?: number
	wikipediaResponseMilliseconds?: number
	amazonResponseMilliseconds?: number
	ipv4Status?: 0 | 1
	ipv6Status?: 0 | 1
	uptime?: string
	cpuUsePercentage?: number
	freeMemoryBytes?: number
	freeHardDriveBytes?: number
	operatingSystemVersion?: string
	firmwareVersion?: string
}

export enum RouterType {
	Property = "Property",
	Unit = "Unit",
}

export interface Plan {
	id: string
	name: string
	downloadMbpsLimit: number
	uploadMbpsLimit: number
}

export interface Agreement {
	id: string
	tenantId: number
	tenantName: string
	propertyId: number
	unitId: number
	routerId: string
	planId: string
	startDate: string
	endDate?: string
	rmSyncStatus?: string
}

export interface RouterStatus {
	id: string
	date: string
	routerId: string
	norhartResponseMilliseconds: number
	googleResponseMilliseconds: number
	youTubeResponseMilliseconds: number
	wikipediaResponseMilliseconds: number
	amazonResponseMilliseconds: number
	ipv4Status: 0 | 1
	ipv6Status: 0 | 1
	uptime: string
	cpuUsePercentage: number
	freeMemoryBytes: number
	freeHardDriveBytes: number
	operatingSystemVersion: string
	firmwareVersion: string
}

export interface ConfigScriptTemplate {
	id: string
	name: string
	type: RouterType
	model: string
	osVersion: string
	template: string
}

export interface Property {
	id: number
	name: string
}

export interface Unit {
	id: number
	name: string
	propertyId: number
}

export interface Tenant {
	id: number
	name: string
	propertyId: number
	propertyName: string
	unitId: number
	unitName: string
}

export enum Group {
	InternetManagement = "InternetManagement",
	InternetManagementManager = "InternetManagementManager",
	InternetManagementAdmin = "InternetManagementAdmin",
	GlobalAdmin = "GlobalAdmin",
}
